export const optionFormatter = (i) => ({
  ...i,
  value: i.id,
  label: i.value
})
